import type { UrlSegmentGroup, UrlTree } from '@angular/router';

type UrlSegmentGroupMap = Record<string, UrlSegmentGroup>;

const treeCleaner = (
  cond: (outletName: string) => boolean,
  segments: UrlSegmentGroupMap,
): UrlSegmentGroupMap => {
  const result: UrlSegmentGroupMap = {};

  for (const outletName in segments) {
    if (cond(outletName)) {
      result[outletName] = segments[outletName];
      if (result[outletName].hasChildren()) {
        result[outletName].children = treeCleaner(cond, result[outletName].children);
      }
    }
  }

  return result;
};

export const stripChildrenOutlets = (excludedOutlets: string[], tree: UrlTree) => {
  tree.root.children = treeCleaner(
    outletName => !excludedOutlets.includes(outletName),
    tree.root.children,
  );

  return tree;
};

export const keepChildrenOutlets = (includedOutlets: string[], tree: UrlTree) => {
  tree.root.children = treeCleaner(
    outletName => includedOutlets.includes(outletName),
    tree.root.children,
  );

  return tree;
};
